//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import dayjs from 'dayjs';

export class AuthControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * User login
     */
    login(body: UserLoginDto , cancelToken?: CancelToken | undefined): Promise<AuthToken> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthToken.fromJS(resultData200);
            return Promise.resolve<AuthToken>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundException.fromJS(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthToken>(null as any);
    }

    /**
     * Returns boolean value indicating if token is valid
     */
    verifyToken(body: VerifyTokenArgs , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/auth/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyToken(_response);
        });
    }

    protected processVerifyToken(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Returns user profile from token if token is valid, otherwise returns undefined
     */
    profile(body: VerifyTokenArgs , cancelToken?: CancelToken | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/auth/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile(_response);
        });
    }

    protected processProfile(response: AxiosResponse): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileDto.fromJS(resultData200);
            return Promise.resolve<UserProfileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }
}

export class UserControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get current user profile
     */
    profile(  cancelToken?: CancelToken | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/user/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProfile(_response);
        });
    }

    protected processProfile(response: AxiosResponse): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileDto.fromJS(resultData200);
            return Promise.resolve<UserProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = UnauthorizedException.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    /**
     * Update current user profile
     */
    updateProfile(body: UpdateUserProfileDto , cancelToken?: CancelToken | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/user/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileDto.fromJS(resultData200);
            return Promise.resolve<UserProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = UnauthorizedException.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    /**
     * Get user by id
     * @param id user id
     */
    get(id: string , cancelToken?: CancelToken | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileDto.fromJS(resultData200);
            return Promise.resolve<UserProfileDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    /**
     * Delete existinguser
     * @param id user id
     * @return User deleted successfuly
     */
    delete(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("User not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add new user
     */
    add(body: UserCreateDto , cancelToken?: CancelToken | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileDto.fromJS(resultData200);
            return Promise.resolve<UserProfileDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestException.fromJS(resultData400);
            return throwException("User already exists", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    /**
     * Update existing user
     */
    update(body: UserUpdateDto , cancelToken?: CancelToken | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileDto.fromJS(resultData200);
            return Promise.resolve<UserProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = UnauthorizedException.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    /**
     * Find users
     */
    find(body: FindUsersArgs , cancelToken?: CancelToken | undefined): Promise<UserPaginationDto> {
        let url_ = this.baseUrl + "/user/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<UserPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserPaginationDto.fromJS(resultData200);
            return Promise.resolve<UserPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = UnauthorizedException.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPaginationDto>(null as any);
    }
}

export class SystemLogControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Find system logs
     */
    find(body: FindSystemLogsArgs , cancelToken?: CancelToken | undefined): Promise<SystemLogPaginationDto> {
        let url_ = this.baseUrl + "/log/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<SystemLogPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemLogPaginationDto.fromJS(resultData200);
            return Promise.resolve<SystemLogPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemLogPaginationDto>(null as any);
    }
}

export class CommonControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns the number of milliseconds elapsed since midnight, January 1, 1970 Universal Coordinated Time (UTC)
     */
    time(  cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/common/time";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTime(_response);
        });
    }

    protected processTime(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class FileControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Download file
     * @param name file name to download
     */
    download(name: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/file/download/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Uploads file
     * @param file (optional) 
     */
    upload(file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<UploadFileResultDto> {
        let url_ = this.baseUrl + "/file/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<UploadFileResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadFileResultDto.fromJS(resultData200);
            return Promise.resolve<UploadFileResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFileResultDto>(null as any);
    }

    /**
     * Returns sheets from XLSX file
     * @param fileName uploaded file name
     */
    sheets(fileName: string , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/file/sheets?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSheets(_response);
        });
    }

    protected processSheets(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Returns columns from CSV or XLSX file
     * @param fileName uploaded file name
     * @param sheet (optional) required for XLSX: sheet name
     * @param headerRow (optional) required for XLSX: sheet header row that contains column names
     */
    columns(fileName: string, sheet: string | undefined, headerRow: number | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/file/columns?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (sheet === null)
            throw new Error("The parameter 'sheet' cannot be null.");
        else if (sheet !== undefined)
            url_ += "sheet=" + encodeURIComponent("" + sheet) + "&";
        if (headerRow === null)
            throw new Error("The parameter 'headerRow' cannot be null.");
        else if (headerRow !== undefined)
            url_ += "headerRow=" + encodeURIComponent("" + headerRow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processColumns(_response);
        });
    }

    protected processColumns(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Returns columns suggestions from CSV or XLSX file
     * @param fileName uploaded file name
     * @param sheet (optional) required for XLSX: sheet name
     * @param headerRow (optional) required for XLSX: sheet header row that contains column names
     */
    suggestion(fileName: string, sheet: string | undefined, headerRow: number | undefined , cancelToken?: CancelToken | undefined): Promise<ImportColumnsSuggestionDto> {
        let url_ = this.baseUrl + "/file/suggestion?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined and cannot be null.");
        else
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (sheet === null)
            throw new Error("The parameter 'sheet' cannot be null.");
        else if (sheet !== undefined)
            url_ += "sheet=" + encodeURIComponent("" + sheet) + "&";
        if (headerRow === null)
            throw new Error("The parameter 'headerRow' cannot be null.");
        else if (headerRow !== undefined)
            url_ += "headerRow=" + encodeURIComponent("" + headerRow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuggestion(_response);
        });
    }

    protected processSuggestion(response: AxiosResponse): Promise<ImportColumnsSuggestionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportColumnsSuggestionDto.fromJS(resultData200);
            return Promise.resolve<ImportColumnsSuggestionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportColumnsSuggestionDto>(null as any);
    }
}

export class SystemSettingsControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get system settings
     */
    get(  cancelToken?: CancelToken | undefined): Promise<SystemSettingsDto> {
        let url_ = this.baseUrl + "/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SystemSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemSettingsDto.fromJS(resultData200);
            return Promise.resolve<SystemSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemSettingsDto>(null as any);
    }

    /**
     * Update system settings
     */
    update(body: SystemSettingsDto , cancelToken?: CancelToken | undefined): Promise<SystemSettingsDto> {
        let url_ = this.baseUrl + "/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SystemSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemSettingsDto.fromJS(resultData200);
            return Promise.resolve<SystemSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemSettingsDto>(null as any);
    }
}

export class ProductControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get product by id
     * @param id product id
     */
    get(id: string , cancelToken?: CancelToken | undefined): Promise<ProductDto> {
        let url_ = this.baseUrl + "/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDto.fromJS(resultData200);
            return Promise.resolve<ProductDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Product not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto>(null as any);
    }

    /**
     * Update existing product
     */
    update(body: ProductUpdateDto , cancelToken?: CancelToken | undefined): Promise<ProductDto> {
        let url_ = this.baseUrl + "/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDto.fromJS(resultData200);
            return Promise.resolve<ProductDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Product not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto>(null as any);
    }

    /**
     * Delete existing products
     * @return Product deleted successfuly
     */
    delete(body: DeleteManyArgs , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Product not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Find products
     */
    find(body: FindProductsArgs , cancelToken?: CancelToken | undefined): Promise<ProductPaginationDto> {
        let url_ = this.baseUrl + "/product/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<ProductPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductPaginationDto.fromJS(resultData200);
            return Promise.resolve<ProductPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductPaginationDto>(null as any);
    }
}

export class RetailerControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get retailer by id
     * @param id retailer id
     */
    get(id: string , cancelToken?: CancelToken | undefined): Promise<RetailerDto> {
        let url_ = this.baseUrl + "/retailer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RetailerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerDto.fromJS(resultData200);
            return Promise.resolve<RetailerDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerDto>(null as any);
    }

    /**
     * Delete existing retailer
     * @param cascade cascade delete
     * @param id retailer id
     * @return Retailer deleted successfuly
     */
    delete(cascade: boolean, id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/retailer/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (cascade === undefined || cascade === null)
            throw new Error("The parameter 'cascade' must be defined and cannot be null.");
        else
            url_ += "cascade=" + encodeURIComponent("" + cascade) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add new retailer
     */
    add(body: RetailerAddDto , cancelToken?: CancelToken | undefined): Promise<RetailerDto> {
        let url_ = this.baseUrl + "/retailer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<RetailerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerDto.fromJS(resultData200);
            return Promise.resolve<RetailerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerDto>(null as any);
    }

    /**
     * Update existing retailer
     */
    update(body: RetailerUpdateDto , cancelToken?: CancelToken | undefined): Promise<RetailerDto> {
        let url_ = this.baseUrl + "/retailer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RetailerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerDto.fromJS(resultData200);
            return Promise.resolve<RetailerDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerDto>(null as any);
    }

    /**
     * Find retailers
     */
    find(body: FindRetailersArgs , cancelToken?: CancelToken | undefined): Promise<RetailerPaginationDto> {
        let url_ = this.baseUrl + "/retailer/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<RetailerPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerPaginationDto.fromJS(resultData200);
            return Promise.resolve<RetailerPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerPaginationDto>(null as any);
    }

    /**
     * Get retailer template by id
     * @param id retailer id
     */
    template(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/retailer/template/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTemplate(_response);
        });
    }

    protected processTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class RetailerProductControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get retailer product by id
     * @param retailerId retailer id
     * @param productId product id
     */
    get(retailerId: string, productId: string , cancelToken?: CancelToken | undefined): Promise<RetailerProductDto> {
        let url_ = this.baseUrl + "/retailer/product/{retailerId}/{productId}";
        if (retailerId === undefined || retailerId === null)
            throw new Error("The parameter 'retailerId' must be defined.");
        url_ = url_.replace("{retailerId}", encodeURIComponent("" + retailerId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RetailerProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerProductDto.fromJS(resultData200);
            return Promise.resolve<RetailerProductDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer product not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerProductDto>(null as any);
    }

    /**
     * Add or update retailer product
     */
    update(body: RetailerProductUpdateDto , cancelToken?: CancelToken | undefined): Promise<RetailerProductDto> {
        let url_ = this.baseUrl + "/retailer/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RetailerProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerProductDto.fromJS(resultData200);
            return Promise.resolve<RetailerProductDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerProductDto>(null as any);
    }

    /**
     * Delete existing retailer product
     * @param retailerId retailer id
     * @return Retailer product deleted successfuly
     */
    delete(retailerId: string, body: DeleteManyArgs , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/retailer/product/{retailerId}";
        if (retailerId === undefined || retailerId === null)
            throw new Error("The parameter 'retailerId' must be defined.");
        url_ = url_.replace("{retailerId}", encodeURIComponent("" + retailerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer product not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Find retailer products
     */
    find(body: FindRetailerProductsArgs , cancelToken?: CancelToken | undefined): Promise<RetailerProductPaginationDto> {
        let url_ = this.baseUrl + "/retailer/product/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<RetailerProductPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerProductPaginationDto.fromJS(resultData200);
            return Promise.resolve<RetailerProductPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerProductPaginationDto>(null as any);
    }

    /**
     * Import retailer products
     */
    importProducts(body: ImportRetailerProductsArgs , cancelToken?: CancelToken | undefined): Promise<ImportRetailerProductsResultDto> {
        let url_ = this.baseUrl + "/retailer/product/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportProducts(_response);
        });
    }

    protected processImportProducts(response: AxiosResponse): Promise<ImportRetailerProductsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportRetailerProductsResultDto.fromJS(resultData200);
            return Promise.resolve<ImportRetailerProductsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportRetailerProductsResultDto>(null as any);
    }
}

export class RetailerVendorControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get retailer vendor by id
     * @param retailerId retailer id
     * @param vendorId vendor id
     */
    get(retailerId: string, vendorId: string , cancelToken?: CancelToken | undefined): Promise<RetailerVendorDto> {
        let url_ = this.baseUrl + "/retailer/vendor/{retailerId}/{vendorId}";
        if (retailerId === undefined || retailerId === null)
            throw new Error("The parameter 'retailerId' must be defined.");
        url_ = url_.replace("{retailerId}", encodeURIComponent("" + retailerId));
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RetailerVendorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerVendorDto.fromJS(resultData200);
            return Promise.resolve<RetailerVendorDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer vendor not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerVendorDto>(null as any);
    }

    /**
     * Delete existing retailer vendor
     * @param cascade cascade delete
     * @param vendorId vendor id
     * @param retailerId retailer id
     * @return Retailer vendor deleted successfuly
     */
    delete(cascade: boolean, vendorId: string, retailerId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/retailer/vendor/{retailerId}/{vendorId}?";
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        if (retailerId === undefined || retailerId === null)
            throw new Error("The parameter 'retailerId' must be defined.");
        url_ = url_.replace("{retailerId}", encodeURIComponent("" + retailerId));
        if (cascade === undefined || cascade === null)
            throw new Error("The parameter 'cascade' must be defined and cannot be null.");
        else
            url_ += "cascade=" + encodeURIComponent("" + cascade) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer vendor not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add or update retailer vendor
     */
    update(body: RetailerVendorUpdateDto , cancelToken?: CancelToken | undefined): Promise<RetailerVendorDto> {
        let url_ = this.baseUrl + "/retailer/vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RetailerVendorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerVendorDto.fromJS(resultData200);
            return Promise.resolve<RetailerVendorDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Retailer not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerVendorDto>(null as any);
    }

    /**
     * Find retailer vendors
     */
    find(body: FindRetailerVendorsArgs , cancelToken?: CancelToken | undefined): Promise<RetailerVendorPaginationDto> {
        let url_ = this.baseUrl + "/retailer/vendor/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<RetailerVendorPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerVendorPaginationDto.fromJS(resultData200);
            return Promise.resolve<RetailerVendorPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerVendorPaginationDto>(null as any);
    }

    /**
     * Find retailer vendor logs
     */
    logs(body: FindRetailerVendorLogsArgs , cancelToken?: CancelToken | undefined): Promise<RetailerVendorLogPaginationDto> {
        let url_ = this.baseUrl + "/retailer/vendor/logs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: AxiosResponse): Promise<RetailerVendorLogPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerVendorLogPaginationDto.fromJS(resultData200);
            return Promise.resolve<RetailerVendorLogPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerVendorLogPaginationDto>(null as any);
    }

    /**
     * Export retailer vendor products
     */
    export(body: RetailerVendorExportDto , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/retailer/vendor/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Send retailer vendor products
     */
    send(body: RetailerVendorExportDto , cancelToken?: CancelToken | undefined): Promise<RetailerVendorLogDto> {
        let url_ = this.baseUrl + "/retailer/vendor/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<RetailerVendorLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RetailerVendorLogDto.fromJS(resultData200);
            return Promise.resolve<RetailerVendorLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetailerVendorLogDto>(null as any);
    }
}

export class SchedulerControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns last scheduler status
     */
    status(  cancelToken?: CancelToken | undefined): Promise<SchedulerStatus> {
        let url_ = this.baseUrl + "/scheduler/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: AxiosResponse): Promise<SchedulerStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchedulerStatus.fromJS(resultData200);
            return Promise.resolve<SchedulerStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchedulerStatus>(null as any);
    }

    /**
     * Runs scheduler now and returns last scheduler status
     */
    run(  cancelToken?: CancelToken | undefined): Promise<SchedulerStatus> {
        let url_ = this.baseUrl + "/scheduler/run";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRun(_response);
        });
    }

    protected processRun(response: AxiosResponse): Promise<SchedulerStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchedulerStatus.fromJS(resultData200);
            return Promise.resolve<SchedulerStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchedulerStatus>(null as any);
    }
}

export class VendorControllerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get vendor by id
     * @param id vendor id
     */
    get(id: string , cancelToken?: CancelToken | undefined): Promise<VendorDto> {
        let url_ = this.baseUrl + "/vendor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<VendorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorDto.fromJS(resultData200);
            return Promise.resolve<VendorDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Vendor not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorDto>(null as any);
    }

    /**
     * Delete existing vendor
     * @param cascade cascade delete
     * @param id vendor id
     * @return Vendor deleted successfuly
     */
    delete(cascade: boolean, id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/vendor/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (cascade === undefined || cascade === null)
            throw new Error("The parameter 'cascade' must be defined and cannot be null.");
        else
            url_ += "cascade=" + encodeURIComponent("" + cascade) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Vendor not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add new vendor
     */
    add(body: VendorAddDto , cancelToken?: CancelToken | undefined): Promise<VendorDto> {
        let url_ = this.baseUrl + "/vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<VendorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorDto.fromJS(resultData200);
            return Promise.resolve<VendorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorDto>(null as any);
    }

    /**
     * Update existing vendor
     */
    update(body: VendorUpdateDto , cancelToken?: CancelToken | undefined): Promise<VendorDto> {
        let url_ = this.baseUrl + "/vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VendorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorDto.fromJS(resultData200);
            return Promise.resolve<VendorDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Vendor not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorDto>(null as any);
    }

    /**
     * Find vendors
     */
    find(body: FindVendorsArgs , cancelToken?: CancelToken | undefined): Promise<VendorPaginationDto> {
        let url_ = this.baseUrl + "/vendor/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: AxiosResponse): Promise<VendorPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorPaginationDto.fromJS(resultData200);
            return Promise.resolve<VendorPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorPaginationDto>(null as any);
    }

    /**
     * Find vendor logs
     */
    logs(body: FindVendorLogsArgs , cancelToken?: CancelToken | undefined): Promise<VendorLogPaginationDto> {
        let url_ = this.baseUrl + "/vendor/logs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: AxiosResponse): Promise<VendorLogPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorLogPaginationDto.fromJS(resultData200);
            return Promise.resolve<VendorLogPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorLogPaginationDto>(null as any);
    }

    /**
     * Import vendor products
     */
    importProducts(body: ImportProductsArgs , cancelToken?: CancelToken | undefined): Promise<ImportProductsResultDto> {
        let url_ = this.baseUrl + "/vendor/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportProducts(_response);
        });
    }

    protected processImportProducts(response: AxiosResponse): Promise<ImportProductsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportProductsResultDto.fromJS(resultData200);
            return Promise.resolve<ImportProductsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportProductsResultDto>(null as any);
    }

    /**
     * Discontinue vendor products
     */
    discontinueProducts(body: DiscontinueProductsArgs , cancelToken?: CancelToken | undefined): Promise<DiscontinueProductsResultDto> {
        let url_ = this.baseUrl + "/vendor/discontinue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscontinueProducts(_response);
        });
    }

    protected processDiscontinueProducts(response: AxiosResponse): Promise<DiscontinueProductsResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscontinueProductsResultDto.fromJS(resultData200);
            return Promise.resolve<DiscontinueProductsResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscontinueProductsResultDto>(null as any);
    }

    /**
     * Download vendor products
     * @param id vendor id
     */
    download(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/vendor/download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserLoginDto implements IUserLoginDto {
    email!: string;
    password!: string;

    [key: string]: any;

    constructor(data?: IUserLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserLoginDto {
    email: string;
    password: string;

    [key: string]: any;
}

export class AuthToken implements IAuthToken {
    id!: string;
    email!: string;
    role!: string;
    token!: string;

    [key: string]: any;

    constructor(data?: IAuthToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthToken {
        data = typeof data === 'object' ? data : {};
        let result = new AuthToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["email"] = this.email;
        data["role"] = this.role;
        data["token"] = this.token;
        return data;
    }
}

export interface IAuthToken {
    id: string;
    email: string;
    role: string;
    token: string;

    [key: string]: any;
}

export class NotFoundException implements INotFoundException {

    [key: string]: any;

    constructor(data?: INotFoundException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): NotFoundException {
        data = typeof data === 'object' ? data : {};
        let result = new NotFoundException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface INotFoundException {

    [key: string]: any;
}

export class VerifyTokenArgs implements IVerifyTokenArgs {
    token!: string;

    [key: string]: any;

    constructor(data?: IVerifyTokenArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): VerifyTokenArgs {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyTokenArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        return data;
    }
}

export interface IVerifyTokenArgs {
    token: string;

    [key: string]: any;
}

export class UserProfileDto implements IUserProfileDto {
    id?: string;
    email?: string;
    role?: UserProfileDtoRole;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.isEnabled = _data["isEnabled"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["email"] = this.email;
        data["role"] = this.role;
        data["isEnabled"] = this.isEnabled;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserProfileDto {
    id?: string;
    email?: string;
    role?: UserProfileDtoRole;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class UnauthorizedException implements IUnauthorizedException {

    [key: string]: any;

    constructor(data?: IUnauthorizedException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): UnauthorizedException {
        data = typeof data === 'object' ? data : {};
        let result = new UnauthorizedException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IUnauthorizedException {

    [key: string]: any;
}

export class UpdateUserProfileDto implements IUpdateUserProfileDto {
    email?: string;
    password?: string;

    [key: string]: any;

    constructor(data?: IUpdateUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UpdateUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IUpdateUserProfileDto {
    email?: string;
    password?: string;

    [key: string]: any;
}

export class UserCreateDto implements IUserCreateDto {
    email!: string;
    password!: string;
    role!: UserCreateDtoRole;
    isEnabled!: boolean;

    [key: string]: any;

    constructor(data?: IUserCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.password = _data["password"];
            this.role = _data["role"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UserCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["password"] = this.password;
        data["role"] = this.role;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUserCreateDto {
    email: string;
    password: string;
    role: UserCreateDtoRole;
    isEnabled: boolean;

    [key: string]: any;
}

export class BadRequestException implements IBadRequestException {

    [key: string]: any;

    constructor(data?: IBadRequestException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): BadRequestException {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IBadRequestException {

    [key: string]: any;
}

export class UserUpdateDto implements IUserUpdateDto {
    id!: string;
    email?: string;
    password?: string;
    role?: UserUpdateDtoRole;
    isEnabled?: boolean;

    [key: string]: any;

    constructor(data?: IUserUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.role = _data["role"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): UserUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["email"] = this.email;
        data["password"] = this.password;
        data["role"] = this.role;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IUserUpdateDto {
    id: string;
    email?: string;
    password?: string;
    role?: UserUpdateDtoRole;
    isEnabled?: boolean;

    [key: string]: any;
}

export class FindUsersArgs implements IFindUsersArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    email?: string;

    [key: string]: any;

    constructor(data?: IFindUsersArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): FindUsersArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["email"] = this.email;
        return data;
    }
}

export interface IFindUsersArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    email?: string;

    [key: string]: any;
}

export class UserPaginationDto implements IUserPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: UserProfileDto[];

    [key: string]: any;

    constructor(data?: IUserPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: UserProfileDto[];

    [key: string]: any;
}

export class FindSystemLogsArgs implements IFindSystemLogsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;

    [key: string]: any;

    constructor(data?: IFindSystemLogsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.eventName = _data["eventName"];
            this.log = _data["log"];
            this.isError = _data["isError"];
        }
    }

    static fromJS(data: any): FindSystemLogsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindSystemLogsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["eventName"] = this.eventName;
        data["log"] = this.log;
        data["isError"] = this.isError;
        return data;
    }
}

export interface IFindSystemLogsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;

    [key: string]: any;
}

export class SystemLogDto implements ISystemLogDto {
    id?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: ISystemLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.eventName = _data["eventName"];
            this.log = _data["log"];
            this.isError = _data["isError"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["eventName"] = this.eventName;
        data["log"] = this.log;
        data["isError"] = this.isError;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISystemLogDto {
    id?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class SystemLogPaginationDto implements ISystemLogPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: SystemLogDto[];

    [key: string]: any;

    constructor(data?: ISystemLogPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SystemLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemLogPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemLogPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemLogPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: SystemLogDto[];

    [key: string]: any;
}

export class UploadFileResultDto implements IUploadFileResultDto {
    name?: string;
    originalname?: string;
    mimetype?: string;
    size?: number;

    [key: string]: any;

    constructor(data?: IUploadFileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.originalname = _data["originalname"];
            this.mimetype = _data["mimetype"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): UploadFileResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["originalname"] = this.originalname;
        data["mimetype"] = this.mimetype;
        data["size"] = this.size;
        return data;
    }
}

export interface IUploadFileResultDto {
    name?: string;
    originalname?: string;
    mimetype?: string;
    size?: number;

    [key: string]: any;
}

export class ImportColumnsSuggestionDto implements IImportColumnsSuggestionDto {
    columnSKU!: string;
    columnQuantity!: string;
    tokenColumns?: string[];

    [key: string]: any;

    constructor(data?: IImportColumnsSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.columnSKU = _data["columnSKU"];
            this.columnQuantity = _data["columnQuantity"];
            if (Array.isArray(_data["tokenColumns"])) {
                this.tokenColumns = [] as any;
                for (let item of _data["tokenColumns"])
                    this.tokenColumns!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportColumnsSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportColumnsSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["columnSKU"] = this.columnSKU;
        data["columnQuantity"] = this.columnQuantity;
        if (Array.isArray(this.tokenColumns)) {
            data["tokenColumns"] = [];
            for (let item of this.tokenColumns)
                data["tokenColumns"].push(item);
        }
        return data;
    }
}

export interface IImportColumnsSuggestionDto {
    columnSKU: string;
    columnQuantity: string;
    tokenColumns?: string[];

    [key: string]: any;
}

export class SmtpSettings implements ISmtpSettings {
    host?: string;
    username?: string;
    password?: string;
    port?: any;
    secure?: boolean;

    [key: string]: any;

    constructor(data?: ISmtpSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.host = _data["host"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.port = _data["port"];
            this.secure = _data["secure"];
        }
    }

    static fromJS(data: any): SmtpSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SmtpSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["host"] = this.host;
        data["username"] = this.username;
        data["password"] = this.password;
        data["port"] = this.port;
        data["secure"] = this.secure;
        return data;
    }
}

export interface ISmtpSettings {
    host?: string;
    username?: string;
    password?: string;
    port?: any;
    secure?: boolean;

    [key: string]: any;
}

export class SystemSettingsDto implements ISystemSettingsDto {
    isSchedulerEnabled!: boolean;
    schedulerTimes?: string;
    smtp?: SmtpSettings;
    twoCaptchaApiKey?: string;

    [key: string]: any;

    constructor(data?: ISystemSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isSchedulerEnabled = _data["isSchedulerEnabled"];
            this.schedulerTimes = _data["schedulerTimes"];
            this.smtp = _data["smtp"] ? SmtpSettings.fromJS(_data["smtp"]) : <any>undefined;
            this.twoCaptchaApiKey = _data["twoCaptchaApiKey"];
        }
    }

    static fromJS(data: any): SystemSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isSchedulerEnabled"] = this.isSchedulerEnabled;
        data["schedulerTimes"] = this.schedulerTimes;
        data["smtp"] = this.smtp ? this.smtp.toJSON() : <any>undefined;
        data["twoCaptchaApiKey"] = this.twoCaptchaApiKey;
        return data;
    }
}

export interface ISystemSettingsDto {
    isSchedulerEnabled: boolean;
    schedulerTimes?: string;
    smtp?: SmtpSettings;
    twoCaptchaApiKey?: string;

    [key: string]: any;
}

export class NameValueItem implements INameValueItem {
    name?: string;
    value?: string;

    [key: string]: any;

    constructor(data?: INameValueItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueItem {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueItem {
    name?: string;
    value?: string;

    [key: string]: any;
}

export class ProductDto implements IProductDto {
    id?: string;
    vendorId?: string;
    sku?: string;
    quantity?: number;
    isDiscontinued?: boolean;
    tokens?: NameValueItem[];
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.vendorId = _data["vendorId"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.isDiscontinued = _data["isDiscontinued"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(NameValueItem.fromJS(item));
            }
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["vendorId"] = this.vendorId;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["isDiscontinued"] = this.isDiscontinued;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductDto {
    id?: string;
    vendorId?: string;
    sku?: string;
    quantity?: number;
    isDiscontinued?: boolean;
    tokens?: NameValueItem[];
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class ProductUpdateDto implements IProductUpdateDto {
    id!: string;
    sku!: string;
    quantity!: number;
    isDiscontinued!: boolean;
    tokens?: NameValueItem[];

    [key: string]: any;

    constructor(data?: IProductUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.isDiscontinued = _data["isDiscontinued"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(NameValueItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["isDiscontinued"] = this.isDiscontinued;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductUpdateDto {
    id: string;
    sku: string;
    quantity: number;
    isDiscontinued: boolean;
    tokens?: NameValueItem[];

    [key: string]: any;
}

export class DeleteManyArgs implements IDeleteManyArgs {
    ids!: string[];
    /** cascade delete */
    cascade?: boolean;

    [key: string]: any;

    constructor(data?: IDeleteManyArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.cascade = _data["cascade"];
        }
    }

    static fromJS(data: any): DeleteManyArgs {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteManyArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["cascade"] = this.cascade;
        return data;
    }
}

export interface IDeleteManyArgs {
    ids: string[];
    /** cascade delete */
    cascade?: boolean;

    [key: string]: any;
}

export class FindProductsArgs implements IFindProductsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    vendorId?: string;
    sku?: string;
    isDiscontinued?: boolean;

    [key: string]: any;

    constructor(data?: IFindProductsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.vendorId = _data["vendorId"];
            this.sku = _data["sku"];
            this.isDiscontinued = _data["isDiscontinued"];
        }
    }

    static fromJS(data: any): FindProductsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindProductsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["vendorId"] = this.vendorId;
        data["sku"] = this.sku;
        data["isDiscontinued"] = this.isDiscontinued;
        return data;
    }
}

export interface IFindProductsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    vendorId?: string;
    sku?: string;
    isDiscontinued?: boolean;

    [key: string]: any;
}

export class ProductPaginationDto implements IProductPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: ProductDto[];

    [key: string]: any;

    constructor(data?: IProductPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: ProductDto[];

    [key: string]: any;
}

export class SftpSettings implements ISftpSettings {
    host?: string;
    username?: string;
    password?: string;
    port?: any;

    [key: string]: any;

    constructor(data?: ISftpSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.host = _data["host"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.port = _data["port"];
        }
    }

    static fromJS(data: any): SftpSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SftpSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["host"] = this.host;
        data["username"] = this.username;
        data["password"] = this.password;
        data["port"] = this.port;
        return data;
    }
}

export interface ISftpSettings {
    host?: string;
    username?: string;
    password?: string;
    port?: any;

    [key: string]: any;
}

export class FtpSettings implements IFtpSettings {
    host?: string;
    username?: string;
    password?: string;
    port?: any;
    secure?: boolean;

    [key: string]: any;

    constructor(data?: IFtpSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.host = _data["host"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.port = _data["port"];
            this.secure = _data["secure"];
        }
    }

    static fromJS(data: any): FtpSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FtpSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["host"] = this.host;
        data["username"] = this.username;
        data["password"] = this.password;
        data["port"] = this.port;
        data["secure"] = this.secure;
        return data;
    }
}

export interface IFtpSettings {
    host?: string;
    username?: string;
    password?: string;
    port?: any;
    secure?: boolean;

    [key: string]: any;
}

export class RetailerSettings implements IRetailerSettings {
    smtp?: SmtpSettings;
    sftp?: SftpSettings;
    ftp?: FtpSettings;
    discontinuedTrue?: string;
    discontinuedFalse?: string;

    [key: string]: any;

    constructor(data?: IRetailerSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.smtp = _data["smtp"] ? SmtpSettings.fromJS(_data["smtp"]) : <any>undefined;
            this.sftp = _data["sftp"] ? SftpSettings.fromJS(_data["sftp"]) : <any>undefined;
            this.ftp = _data["ftp"] ? FtpSettings.fromJS(_data["ftp"]) : <any>undefined;
            this.discontinuedTrue = _data["discontinuedTrue"];
            this.discontinuedFalse = _data["discontinuedFalse"];
        }
    }

    static fromJS(data: any): RetailerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["smtp"] = this.smtp ? this.smtp.toJSON() : <any>undefined;
        data["sftp"] = this.sftp ? this.sftp.toJSON() : <any>undefined;
        data["ftp"] = this.ftp ? this.ftp.toJSON() : <any>undefined;
        data["discontinuedTrue"] = this.discontinuedTrue;
        data["discontinuedFalse"] = this.discontinuedFalse;
        return data;
    }
}

export interface IRetailerSettings {
    smtp?: SmtpSettings;
    sftp?: SftpSettings;
    ftp?: FtpSettings;
    discontinuedTrue?: string;
    discontinuedFalse?: string;

    [key: string]: any;
}

export class RetailerTemplateSettings implements IRetailerTemplateSettings {
    /** Required for XLSX: sheet name where to export data */
    sheet?: string;
    /** Required for XLSX: row that contains template row with tokens to replace, Optional for CSV: header row, default 1 */
    row?: number;

    [key: string]: any;

    constructor(data?: IRetailerTemplateSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sheet = _data["sheet"];
            this.row = _data["row"];
        }
    }

    static fromJS(data: any): RetailerTemplateSettings {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerTemplateSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sheet"] = this.sheet;
        data["row"] = this.row;
        return data;
    }
}

export interface IRetailerTemplateSettings {
    /** Required for XLSX: sheet name where to export data */
    sheet?: string;
    /** Required for XLSX: row that contains template row with tokens to replace, Optional for CSV: header row, default 1 */
    row?: number;

    [key: string]: any;
}

export class RetailerDto implements IRetailerDto {
    id?: string;
    name?: string;
    settings?: RetailerSettings;
    templateFileType?: string;
    templateSettings?: RetailerTemplateSettings;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IRetailerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.settings = _data["settings"] ? RetailerSettings.fromJS(_data["settings"]) : <any>undefined;
            this.templateFileType = _data["templateFileType"];
            this.templateSettings = _data["templateSettings"] ? RetailerTemplateSettings.fromJS(_data["templateSettings"]) : <any>undefined;
            this.isEnabled = _data["isEnabled"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RetailerDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["templateFileType"] = this.templateFileType;
        data["templateSettings"] = this.templateSettings ? this.templateSettings.toJSON() : <any>undefined;
        data["isEnabled"] = this.isEnabled;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRetailerDto {
    id?: string;
    name?: string;
    settings?: RetailerSettings;
    templateFileType?: string;
    templateSettings?: RetailerTemplateSettings;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class RetailerAddDto implements IRetailerAddDto {
    name!: string;
    settings!: RetailerSettings;
    /** name of uploaded file, if not specified template content will not be updated */
    templateFileName!: string;
    templateSettings!: RetailerTemplateSettings;
    isEnabled!: boolean;

    [key: string]: any;

    constructor(data?: IRetailerAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.settings = new RetailerSettings();
            this.templateSettings = new RetailerTemplateSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.settings = _data["settings"] ? RetailerSettings.fromJS(_data["settings"]) : new RetailerSettings();
            this.templateFileName = _data["templateFileName"];
            this.templateSettings = _data["templateSettings"] ? RetailerTemplateSettings.fromJS(_data["templateSettings"]) : new RetailerTemplateSettings();
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): RetailerAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["templateFileName"] = this.templateFileName;
        data["templateSettings"] = this.templateSettings ? this.templateSettings.toJSON() : <any>undefined;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IRetailerAddDto {
    name: string;
    settings: RetailerSettings;
    /** name of uploaded file, if not specified template content will not be updated */
    templateFileName: string;
    templateSettings: RetailerTemplateSettings;
    isEnabled: boolean;

    [key: string]: any;
}

export class RetailerUpdateDto implements IRetailerUpdateDto {
    id!: string;
    name!: string;
    settings!: RetailerSettings;
    /** name of uploaded file, if not specified template content will not be updated */
    templateFileName!: string;
    templateSettings!: RetailerTemplateSettings;
    isEnabled!: boolean;

    [key: string]: any;

    constructor(data?: IRetailerUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.settings = new RetailerSettings();
            this.templateSettings = new RetailerTemplateSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.settings = _data["settings"] ? RetailerSettings.fromJS(_data["settings"]) : new RetailerSettings();
            this.templateFileName = _data["templateFileName"];
            this.templateSettings = _data["templateSettings"] ? RetailerTemplateSettings.fromJS(_data["templateSettings"]) : new RetailerTemplateSettings();
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): RetailerUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["templateFileName"] = this.templateFileName;
        data["templateSettings"] = this.templateSettings ? this.templateSettings.toJSON() : <any>undefined;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IRetailerUpdateDto {
    id: string;
    name: string;
    settings: RetailerSettings;
    /** name of uploaded file, if not specified template content will not be updated */
    templateFileName: string;
    templateSettings: RetailerTemplateSettings;
    isEnabled: boolean;

    [key: string]: any;
}

export class FindRetailersArgs implements IFindRetailersArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    name?: string;

    [key: string]: any;

    constructor(data?: IFindRetailersArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FindRetailersArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindRetailersArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["name"] = this.name;
        return data;
    }
}

export interface IFindRetailersArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    name?: string;

    [key: string]: any;
}

export class RetailerPaginationDto implements IRetailerPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: RetailerDto[];

    [key: string]: any;

    constructor(data?: IRetailerPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RetailerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetailerPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetailerPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: RetailerDto[];

    [key: string]: any;
}

export class RetailerInfoDto implements IRetailerInfoDto {
    id?: string;
    name?: string;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IRetailerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RetailerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRetailerInfoDto {
    id?: string;
    name?: string;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class RetailerProductSettings implements IRetailerProductSettings {
    tokens?: NameValueItem[];
    exclude?: boolean;

    [key: string]: any;

    constructor(data?: IRetailerProductSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(NameValueItem.fromJS(item));
            }
            this.exclude = _data["exclude"];
        }
    }

    static fromJS(data: any): RetailerProductSettings {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerProductSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["exclude"] = this.exclude;
        return data;
    }
}

export interface IRetailerProductSettings {
    tokens?: NameValueItem[];
    exclude?: boolean;

    [key: string]: any;
}

export class RetailerProductDto implements IRetailerProductDto {
    retailerId?: string;
    retailer?: RetailerInfoDto;
    productId?: string;
    product?: ProductDto;
    settings?: RetailerProductSettings;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IRetailerProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.retailerId = _data["retailerId"];
            this.retailer = _data["retailer"] ? RetailerInfoDto.fromJS(_data["retailer"]) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            this.settings = _data["settings"] ? RetailerProductSettings.fromJS(_data["settings"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RetailerProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["retailerId"] = this.retailerId;
        data["retailer"] = this.retailer ? this.retailer.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRetailerProductDto {
    retailerId?: string;
    retailer?: RetailerInfoDto;
    productId?: string;
    product?: ProductDto;
    settings?: RetailerProductSettings;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class RetailerProductUpdateDto implements IRetailerProductUpdateDto {
    retailerId!: string;
    productId!: string;
    settings!: RetailerProductSettings;

    [key: string]: any;

    constructor(data?: IRetailerProductUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.settings = new RetailerProductSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.retailerId = _data["retailerId"];
            this.productId = _data["productId"];
            this.settings = _data["settings"] ? RetailerProductSettings.fromJS(_data["settings"]) : new RetailerProductSettings();
        }
    }

    static fromJS(data: any): RetailerProductUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerProductUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["retailerId"] = this.retailerId;
        data["productId"] = this.productId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRetailerProductUpdateDto {
    retailerId: string;
    productId: string;
    settings: RetailerProductSettings;

    [key: string]: any;
}

export class FindRetailerProductsArgs implements IFindRetailerProductsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    retailerId!: string;
    sku?: string;

    [key: string]: any;

    constructor(data?: IFindRetailerProductsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.retailerId = _data["retailerId"];
            this.sku = _data["sku"];
        }
    }

    static fromJS(data: any): FindRetailerProductsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindRetailerProductsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["retailerId"] = this.retailerId;
        data["sku"] = this.sku;
        return data;
    }
}

export interface IFindRetailerProductsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    retailerId: string;
    sku?: string;

    [key: string]: any;
}

export class RetailerProductPaginationDto implements IRetailerProductPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: RetailerProductDto[];

    [key: string]: any;

    constructor(data?: IRetailerProductPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RetailerProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetailerProductPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerProductPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetailerProductPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: RetailerProductDto[];

    [key: string]: any;
}

export class ImportRetailerProductsArgs implements IImportRetailerProductsArgs {
    fileName!: string;
    retailerId!: string;
    exclude!: boolean;
    columnSKU!: string;
    tokenColumns?: string[];
    /** required for XLSX: sheet name */
    sheet?: string;
    /** required for XLSX: row that contains column names */
    headerRow?: number;
    /** required for XLSX: first row that contains data */
    dataRow?: number;

    [key: string]: any;

    constructor(data?: IImportRetailerProductsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"];
            this.retailerId = _data["retailerId"];
            this.exclude = _data["exclude"];
            this.columnSKU = _data["columnSKU"];
            if (Array.isArray(_data["tokenColumns"])) {
                this.tokenColumns = [] as any;
                for (let item of _data["tokenColumns"])
                    this.tokenColumns!.push(item);
            }
            this.sheet = _data["sheet"];
            this.headerRow = _data["headerRow"];
            this.dataRow = _data["dataRow"];
        }
    }

    static fromJS(data: any): ImportRetailerProductsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRetailerProductsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName;
        data["retailerId"] = this.retailerId;
        data["exclude"] = this.exclude;
        data["columnSKU"] = this.columnSKU;
        if (Array.isArray(this.tokenColumns)) {
            data["tokenColumns"] = [];
            for (let item of this.tokenColumns)
                data["tokenColumns"].push(item);
        }
        data["sheet"] = this.sheet;
        data["headerRow"] = this.headerRow;
        data["dataRow"] = this.dataRow;
        return data;
    }
}

export interface IImportRetailerProductsArgs {
    fileName: string;
    retailerId: string;
    exclude: boolean;
    columnSKU: string;
    tokenColumns?: string[];
    /** required for XLSX: sheet name */
    sheet?: string;
    /** required for XLSX: row that contains column names */
    headerRow?: number;
    /** required for XLSX: first row that contains data */
    dataRow?: number;

    [key: string]: any;
}

export class ImportRetailerProductsResultDto implements IImportRetailerProductsResultDto {
    inserted?: number;
    updated?: number;

    [key: string]: any;

    constructor(data?: IImportRetailerProductsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.inserted = _data["inserted"];
            this.updated = _data["updated"];
        }
    }

    static fromJS(data: any): ImportRetailerProductsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRetailerProductsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["inserted"] = this.inserted;
        data["updated"] = this.updated;
        return data;
    }
}

export interface IImportRetailerProductsResultDto {
    inserted?: number;
    updated?: number;

    [key: string]: any;
}

export class VendorDto implements IVendorDto {
    id?: string;
    name?: string;
    supplierId?: string;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.supplierId = _data["supplierId"];
            this.isEnabled = _data["isEnabled"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["supplierId"] = this.supplierId;
        data["isEnabled"] = this.isEnabled;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVendorDto {
    id?: string;
    name?: string;
    supplierId?: string;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class RetailerVendorMailSettings implements IRetailerVendorMailSettings {
    fromEmail!: string;
    fromName?: string;
    toEmail!: string;
    subject!: string;
    text?: string;
    html?: string;

    [key: string]: any;

    constructor(data?: IRetailerVendorMailSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
            this.toEmail = _data["toEmail"];
            this.subject = _data["subject"];
            this.text = _data["text"];
            this.html = _data["html"];
        }
    }

    static fromJS(data: any): RetailerVendorMailSettings {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorMailSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        data["toEmail"] = this.toEmail;
        data["subject"] = this.subject;
        data["text"] = this.text;
        data["html"] = this.html;
        return data;
    }
}

export interface IRetailerVendorMailSettings {
    fromEmail: string;
    fromName?: string;
    toEmail: string;
    subject: string;
    text?: string;
    html?: string;

    [key: string]: any;
}

export class WalmartSettings implements IWalmartSettings {
    clientId?: string;
    clientSecret?: string;
    sandbox?: boolean;

    [key: string]: any;

    constructor(data?: IWalmartSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.sandbox = _data["sandbox"];
        }
    }

    static fromJS(data: any): WalmartSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WalmartSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["sandbox"] = this.sandbox;
        return data;
    }
}

export interface IWalmartSettings {
    clientId?: string;
    clientSecret?: string;
    sandbox?: boolean;

    [key: string]: any;
}

export class CommerceHubSettings implements ICommerceHubSettings {
    email?: string;
    password?: string;
    profile?: string;
    sandbox?: boolean;

    [key: string]: any;

    constructor(data?: ICommerceHubSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.password = _data["password"];
            this.profile = _data["profile"];
            this.sandbox = _data["sandbox"];
        }
    }

    static fromJS(data: any): CommerceHubSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CommerceHubSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["password"] = this.password;
        data["profile"] = this.profile;
        data["sandbox"] = this.sandbox;
        return data;
    }
}

export interface ICommerceHubSettings {
    email?: string;
    password?: string;
    profile?: string;
    sandbox?: boolean;

    [key: string]: any;
}

export enum OTPEnum {
    None = "none",
    Dialpad = "dialpad",
}

export class DialpadSettings implements IDialpadSettings {
    enabled?: boolean;
    email?: string;
    password?: string;
    department?: string;
    inbox?: string;

    [key: string]: any;

    constructor(data?: IDialpadSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.department = _data["department"];
            this.inbox = _data["inbox"];
        }
    }

    static fromJS(data: any): DialpadSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DialpadSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["email"] = this.email;
        data["password"] = this.password;
        data["department"] = this.department;
        data["inbox"] = this.inbox;
        return data;
    }
}

export interface IDialpadSettings {
    enabled?: boolean;
    email?: string;
    password?: string;
    department?: string;
    inbox?: string;

    [key: string]: any;
}

export class AmazonSettings implements IAmazonSettings {
    email?: string;
    password?: string;
    market?: string;
    otp?: OTPEnum;
    dialpad?: DialpadSettings;

    [key: string]: any;

    constructor(data?: IAmazonSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.password = _data["password"];
            this.market = _data["market"];
            this.otp = _data["otp"];
            this.dialpad = _data["dialpad"] ? DialpadSettings.fromJS(_data["dialpad"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AmazonSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AmazonSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["password"] = this.password;
        data["market"] = this.market;
        data["otp"] = this.otp;
        data["dialpad"] = this.dialpad ? this.dialpad.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAmazonSettings {
    email?: string;
    password?: string;
    market?: string;
    otp?: OTPEnum;
    dialpad?: DialpadSettings;

    [key: string]: any;
}

export class OverstockSettings implements IOverstockSettings {
    username?: string;
    password?: string;

    [key: string]: any;

    constructor(data?: IOverstockSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): OverstockSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OverstockSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IOverstockSettings {
    username?: string;
    password?: string;

    [key: string]: any;
}

export class FaireSettings implements IFaireSettings {
    apiKey?: string;

    [key: string]: any;

    constructor(data?: IFaireSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): FaireSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FaireSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IFaireSettings {
    apiKey?: string;

    [key: string]: any;
}

export class RetailerVendorSettings implements IRetailerVendorSettings {
    tokens?: NameValueItem[];
    sendMethod?: RetailerVendorSettingsSendMethod;
    smtp?: SmtpSettings;
    mail?: RetailerVendorMailSettings;
    sftp?: SftpSettings;
    ftp?: FtpSettings;
    remotePath?: string;
    walmart?: WalmartSettings;
    commerceHub?: CommerceHubSettings;
    amazon?: AmazonSettings;
    overstock?: OverstockSettings;
    faire?: FaireSettings;
    fileName?: string;
    schedulerMode?: RetailerVendorSettingsSchedulerMode;
    schedulerTimes?: string;

    [key: string]: any;

    constructor(data?: IRetailerVendorSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(NameValueItem.fromJS(item));
            }
            this.sendMethod = _data["sendMethod"];
            this.smtp = _data["smtp"] ? SmtpSettings.fromJS(_data["smtp"]) : <any>undefined;
            this.mail = _data["mail"] ? RetailerVendorMailSettings.fromJS(_data["mail"]) : <any>undefined;
            this.sftp = _data["sftp"] ? SftpSettings.fromJS(_data["sftp"]) : <any>undefined;
            this.ftp = _data["ftp"] ? FtpSettings.fromJS(_data["ftp"]) : <any>undefined;
            this.remotePath = _data["remotePath"];
            this.walmart = _data["walmart"] ? WalmartSettings.fromJS(_data["walmart"]) : <any>undefined;
            this.commerceHub = _data["commerceHub"] ? CommerceHubSettings.fromJS(_data["commerceHub"]) : <any>undefined;
            this.amazon = _data["amazon"] ? AmazonSettings.fromJS(_data["amazon"]) : <any>undefined;
            this.overstock = _data["overstock"] ? OverstockSettings.fromJS(_data["overstock"]) : <any>undefined;
            this.faire = _data["faire"] ? FaireSettings.fromJS(_data["faire"]) : <any>undefined;
            this.fileName = _data["fileName"];
            this.schedulerMode = _data["schedulerMode"];
            this.schedulerTimes = _data["schedulerTimes"];
        }
    }

    static fromJS(data: any): RetailerVendorSettings {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["sendMethod"] = this.sendMethod;
        data["smtp"] = this.smtp ? this.smtp.toJSON() : <any>undefined;
        data["mail"] = this.mail ? this.mail.toJSON() : <any>undefined;
        data["sftp"] = this.sftp ? this.sftp.toJSON() : <any>undefined;
        data["ftp"] = this.ftp ? this.ftp.toJSON() : <any>undefined;
        data["remotePath"] = this.remotePath;
        data["walmart"] = this.walmart ? this.walmart.toJSON() : <any>undefined;
        data["commerceHub"] = this.commerceHub ? this.commerceHub.toJSON() : <any>undefined;
        data["amazon"] = this.amazon ? this.amazon.toJSON() : <any>undefined;
        data["overstock"] = this.overstock ? this.overstock.toJSON() : <any>undefined;
        data["faire"] = this.faire ? this.faire.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["schedulerMode"] = this.schedulerMode;
        data["schedulerTimes"] = this.schedulerTimes;
        return data;
    }
}

export interface IRetailerVendorSettings {
    tokens?: NameValueItem[];
    sendMethod?: RetailerVendorSettingsSendMethod;
    smtp?: SmtpSettings;
    mail?: RetailerVendorMailSettings;
    sftp?: SftpSettings;
    ftp?: FtpSettings;
    remotePath?: string;
    walmart?: WalmartSettings;
    commerceHub?: CommerceHubSettings;
    amazon?: AmazonSettings;
    overstock?: OverstockSettings;
    faire?: FaireSettings;
    fileName?: string;
    schedulerMode?: RetailerVendorSettingsSchedulerMode;
    schedulerTimes?: string;

    [key: string]: any;
}

export class RetailerVendorDto implements IRetailerVendorDto {
    retailerId?: string;
    retailer?: RetailerInfoDto;
    vendorId?: string;
    vendor?: VendorDto;
    settings?: RetailerVendorSettings;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;
    lastSendAt?: dayjs.Dayjs;
    lastJobAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IRetailerVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.retailerId = _data["retailerId"];
            this.retailer = _data["retailer"] ? RetailerInfoDto.fromJS(_data["retailer"]) : <any>undefined;
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.settings = _data["settings"] ? RetailerVendorSettings.fromJS(_data["settings"]) : <any>undefined;
            this.isEnabled = _data["isEnabled"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
            this.lastSendAt = _data["lastSendAt"] ? dayjs(_data["lastSendAt"].toString()) : <any>undefined;
            this.lastJobAt = _data["lastJobAt"] ? dayjs(_data["lastJobAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RetailerVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["retailerId"] = this.retailerId;
        data["retailer"] = this.retailer ? this.retailer.toJSON() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["isEnabled"] = this.isEnabled;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["lastSendAt"] = this.lastSendAt ? this.lastSendAt.toISOString() : <any>undefined;
        data["lastJobAt"] = this.lastJobAt ? this.lastJobAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRetailerVendorDto {
    retailerId?: string;
    retailer?: RetailerInfoDto;
    vendorId?: string;
    vendor?: VendorDto;
    settings?: RetailerVendorSettings;
    isEnabled?: boolean;
    createdAt?: dayjs.Dayjs;
    updatedAt?: dayjs.Dayjs;
    lastSendAt?: dayjs.Dayjs;
    lastJobAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class RetailerVendorUpdateDto implements IRetailerVendorUpdateDto {
    retailerId!: string;
    vendorId!: string;
    settings!: RetailerVendorSettings;
    isEnabled!: boolean;

    [key: string]: any;

    constructor(data?: IRetailerVendorUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.settings = new RetailerVendorSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.retailerId = _data["retailerId"];
            this.vendorId = _data["vendorId"];
            this.settings = _data["settings"] ? RetailerVendorSettings.fromJS(_data["settings"]) : new RetailerVendorSettings();
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): RetailerVendorUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["retailerId"] = this.retailerId;
        data["vendorId"] = this.vendorId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IRetailerVendorUpdateDto {
    retailerId: string;
    vendorId: string;
    settings: RetailerVendorSettings;
    isEnabled: boolean;

    [key: string]: any;
}

export class FindRetailerVendorsArgs implements IFindRetailerVendorsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    retailerId!: string;
    name?: string;

    [key: string]: any;

    constructor(data?: IFindRetailerVendorsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.retailerId = _data["retailerId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FindRetailerVendorsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindRetailerVendorsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["retailerId"] = this.retailerId;
        data["name"] = this.name;
        return data;
    }
}

export interface IFindRetailerVendorsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    retailerId: string;
    name?: string;

    [key: string]: any;
}

export class RetailerVendorPaginationDto implements IRetailerVendorPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: RetailerVendorDto[];

    [key: string]: any;

    constructor(data?: IRetailerVendorPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RetailerVendorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetailerVendorPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetailerVendorPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: RetailerVendorDto[];

    [key: string]: any;
}

export class FindRetailerVendorLogsArgs implements IFindRetailerVendorLogsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    retailerId?: string;
    vendorId?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;

    [key: string]: any;

    constructor(data?: IFindRetailerVendorLogsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.retailerId = _data["retailerId"];
            this.vendorId = _data["vendorId"];
            this.eventName = _data["eventName"];
            this.log = _data["log"];
            this.isError = _data["isError"];
        }
    }

    static fromJS(data: any): FindRetailerVendorLogsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindRetailerVendorLogsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["retailerId"] = this.retailerId;
        data["vendorId"] = this.vendorId;
        data["eventName"] = this.eventName;
        data["log"] = this.log;
        data["isError"] = this.isError;
        return data;
    }
}

export interface IFindRetailerVendorLogsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    retailerId?: string;
    vendorId?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;

    [key: string]: any;
}

export class RetailerVendorLogDto implements IRetailerVendorLogDto {
    id?: string;
    retailer?: RetailerInfoDto;
    vendor?: VendorDto;
    eventName?: string;
    log?: string;
    isError?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IRetailerVendorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.retailer = _data["retailer"] ? RetailerInfoDto.fromJS(_data["retailer"]) : <any>undefined;
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.eventName = _data["eventName"];
            this.log = _data["log"];
            this.isError = _data["isError"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RetailerVendorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["retailer"] = this.retailer ? this.retailer.toJSON() : <any>undefined;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["eventName"] = this.eventName;
        data["log"] = this.log;
        data["isError"] = this.isError;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRetailerVendorLogDto {
    id?: string;
    retailer?: RetailerInfoDto;
    vendor?: VendorDto;
    eventName?: string;
    log?: string;
    isError?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class RetailerVendorLogPaginationDto implements IRetailerVendorLogPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: RetailerVendorLogDto[];

    [key: string]: any;

    constructor(data?: IRetailerVendorLogPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RetailerVendorLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetailerVendorLogPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorLogPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetailerVendorLogPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: RetailerVendorLogDto[];

    [key: string]: any;
}

export class RetailerVendorExportDto implements IRetailerVendorExportDto {
    retailerId!: string;
    vendorId!: string;

    [key: string]: any;

    constructor(data?: IRetailerVendorExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.retailerId = _data["retailerId"];
            this.vendorId = _data["vendorId"];
        }
    }

    static fromJS(data: any): RetailerVendorExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerVendorExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["retailerId"] = this.retailerId;
        data["vendorId"] = this.vendorId;
        return data;
    }
}

export interface IRetailerVendorExportDto {
    retailerId: string;
    vendorId: string;

    [key: string]: any;
}

export class SchedulerStatus implements ISchedulerStatus {
    currentTime?: dayjs.Dayjs;
    enabled?: boolean;
    running?: boolean;
    lastCheck?: dayjs.Dayjs;
    total?: number;
    forSending?: number;
    sent?: string[];
    failed?: string[];
    error?: string;
    startedAt?: dayjs.Dayjs;
    finishedAt?: dayjs.Dayjs;
    durationSeconds?: number;

    [key: string]: any;

    constructor(data?: ISchedulerStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.currentTime = _data["currentTime"] ? dayjs(_data["currentTime"].toString()) : <any>undefined;
            this.enabled = _data["enabled"];
            this.running = _data["running"];
            this.lastCheck = _data["lastCheck"] ? dayjs(_data["lastCheck"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.forSending = _data["forSending"];
            if (Array.isArray(_data["sent"])) {
                this.sent = [] as any;
                for (let item of _data["sent"])
                    this.sent!.push(item);
            }
            if (Array.isArray(_data["failed"])) {
                this.failed = [] as any;
                for (let item of _data["failed"])
                    this.failed!.push(item);
            }
            this.error = _data["error"];
            this.startedAt = _data["startedAt"] ? dayjs(_data["startedAt"].toString()) : <any>undefined;
            this.finishedAt = _data["finishedAt"] ? dayjs(_data["finishedAt"].toString()) : <any>undefined;
            this.durationSeconds = _data["durationSeconds"];
        }
    }

    static fromJS(data: any): SchedulerStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["currentTime"] = this.currentTime ? this.currentTime.toISOString() : <any>undefined;
        data["enabled"] = this.enabled;
        data["running"] = this.running;
        data["lastCheck"] = this.lastCheck ? this.lastCheck.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["forSending"] = this.forSending;
        if (Array.isArray(this.sent)) {
            data["sent"] = [];
            for (let item of this.sent)
                data["sent"].push(item);
        }
        if (Array.isArray(this.failed)) {
            data["failed"] = [];
            for (let item of this.failed)
                data["failed"].push(item);
        }
        data["error"] = this.error;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        data["durationSeconds"] = this.durationSeconds;
        return data;
    }
}

export interface ISchedulerStatus {
    currentTime?: dayjs.Dayjs;
    enabled?: boolean;
    running?: boolean;
    lastCheck?: dayjs.Dayjs;
    total?: number;
    forSending?: number;
    sent?: string[];
    failed?: string[];
    error?: string;
    startedAt?: dayjs.Dayjs;
    finishedAt?: dayjs.Dayjs;
    durationSeconds?: number;

    [key: string]: any;
}

export class VendorAddDto implements IVendorAddDto {
    name!: string;
    supplierId!: string;
    isEnabled!: boolean;

    [key: string]: any;

    constructor(data?: IVendorAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.supplierId = _data["supplierId"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): VendorAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["supplierId"] = this.supplierId;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IVendorAddDto {
    name: string;
    supplierId: string;
    isEnabled: boolean;

    [key: string]: any;
}

export class VendorUpdateDto implements IVendorUpdateDto {
    id!: string;
    name!: string;
    supplierId!: string;
    isEnabled!: boolean;

    [key: string]: any;

    constructor(data?: IVendorUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.supplierId = _data["supplierId"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): VendorUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["supplierId"] = this.supplierId;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IVendorUpdateDto {
    id: string;
    name: string;
    supplierId: string;
    isEnabled: boolean;

    [key: string]: any;
}

export class FindVendorsArgs implements IFindVendorsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    name?: string;
    supplierId?: string;

    [key: string]: any;

    constructor(data?: IFindVendorsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.name = _data["name"];
            this.supplierId = _data["supplierId"];
        }
    }

    static fromJS(data: any): FindVendorsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindVendorsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["name"] = this.name;
        data["supplierId"] = this.supplierId;
        return data;
    }
}

export interface IFindVendorsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    name?: string;
    supplierId?: string;

    [key: string]: any;
}

export class VendorPaginationDto implements IVendorPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: VendorDto[];

    [key: string]: any;

    constructor(data?: IVendorPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VendorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VendorPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVendorPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: VendorDto[];

    [key: string]: any;
}

export class FindVendorLogsArgs implements IFindVendorLogsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    vendorId?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;

    [key: string]: any;

    constructor(data?: IFindVendorLogsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.sort = _data["sort"];
            this.vendorId = _data["vendorId"];
            this.eventName = _data["eventName"];
            this.log = _data["log"];
            this.isError = _data["isError"];
        }
    }

    static fromJS(data: any): FindVendorLogsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new FindVendorLogsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["sort"] = this.sort;
        data["vendorId"] = this.vendorId;
        data["eventName"] = this.eventName;
        data["log"] = this.log;
        data["isError"] = this.isError;
        return data;
    }
}

export interface IFindVendorLogsArgs {
    /** One-based index of the page to return. */
    page?: number;
    /** Number of items to return in a single page. */
    size?: number;
    /** Sorting criteria in format "[+|-]property[,...]". Example "+Name,-TimeCreated". */
    sort?: string;
    vendorId?: string;
    eventName?: string;
    log?: string;
    isError?: boolean;

    [key: string]: any;
}

export class VendorLogDto implements IVendorLogDto {
    id?: string;
    vendor?: VendorDto;
    eventName?: string;
    log?: string;
    isError?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;

    constructor(data?: IVendorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.eventName = _data["eventName"];
            this.log = _data["log"];
            this.isError = _data["isError"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VendorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["eventName"] = this.eventName;
        data["log"] = this.log;
        data["isError"] = this.isError;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVendorLogDto {
    id?: string;
    vendor?: VendorDto;
    eventName?: string;
    log?: string;
    isError?: boolean;
    createdAt?: dayjs.Dayjs;

    [key: string]: any;
}

export class VendorLogPaginationDto implements IVendorLogPaginationDto {
    /** requested page number */
    page!: number;
    /** requrest page size */
    size!: number;
    /** total row count */
    count!: number;
    /** total pages */
    pages!: number;
    /** row fetched for requested page */
    fetched!: number;
    /** fetched data */
    data!: VendorLogDto[];

    [key: string]: any;

    constructor(data?: IVendorLogPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"];
            this.size = _data["size"];
            this.count = _data["count"];
            this.pages = _data["pages"];
            this.fetched = _data["fetched"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VendorLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VendorLogPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorLogPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page;
        data["size"] = this.size;
        data["count"] = this.count;
        data["pages"] = this.pages;
        data["fetched"] = this.fetched;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVendorLogPaginationDto {
    /** requested page number */
    page: number;
    /** requrest page size */
    size: number;
    /** total row count */
    count: number;
    /** total pages */
    pages: number;
    /** row fetched for requested page */
    fetched: number;
    /** fetched data */
    data: VendorLogDto[];

    [key: string]: any;
}

export class ImportProductsArgs implements IImportProductsArgs {
    fileName!: string;
    vendorId!: string;
    columnSKU!: string;
    columnQuantity!: string;
    tokenColumns?: string[];
    /** required for XLSX: sheet name */
    sheet?: string;
    /** required for XLSX: row that contains column names */
    headerRow?: number;
    /** required for XLSX: first row that contains data */
    dataRow?: number;
    action?: ImportProductsArgsAction;

    [key: string]: any;

    constructor(data?: IImportProductsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"];
            this.vendorId = _data["vendorId"];
            this.columnSKU = _data["columnSKU"];
            this.columnQuantity = _data["columnQuantity"];
            if (Array.isArray(_data["tokenColumns"])) {
                this.tokenColumns = [] as any;
                for (let item of _data["tokenColumns"])
                    this.tokenColumns!.push(item);
            }
            this.sheet = _data["sheet"];
            this.headerRow = _data["headerRow"];
            this.dataRow = _data["dataRow"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): ImportProductsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProductsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName;
        data["vendorId"] = this.vendorId;
        data["columnSKU"] = this.columnSKU;
        data["columnQuantity"] = this.columnQuantity;
        if (Array.isArray(this.tokenColumns)) {
            data["tokenColumns"] = [];
            for (let item of this.tokenColumns)
                data["tokenColumns"].push(item);
        }
        data["sheet"] = this.sheet;
        data["headerRow"] = this.headerRow;
        data["dataRow"] = this.dataRow;
        data["action"] = this.action;
        return data;
    }
}

export interface IImportProductsArgs {
    fileName: string;
    vendorId: string;
    columnSKU: string;
    columnQuantity: string;
    tokenColumns?: string[];
    /** required for XLSX: sheet name */
    sheet?: string;
    /** required for XLSX: row that contains column names */
    headerRow?: number;
    /** required for XLSX: first row that contains data */
    dataRow?: number;
    action?: ImportProductsArgsAction;

    [key: string]: any;
}

export class ImportProductsResultDto implements IImportProductsResultDto {
    inserted?: number;
    updated?: number;
    discontinued?: number;
    deleted?: number;

    [key: string]: any;

    constructor(data?: IImportProductsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.inserted = _data["inserted"];
            this.updated = _data["updated"];
            this.discontinued = _data["discontinued"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): ImportProductsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProductsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["inserted"] = this.inserted;
        data["updated"] = this.updated;
        data["discontinued"] = this.discontinued;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IImportProductsResultDto {
    inserted?: number;
    updated?: number;
    discontinued?: number;
    deleted?: number;

    [key: string]: any;
}

export class DiscontinueProductsArgs implements IDiscontinueProductsArgs {
    fileName!: string;
    vendorId!: string;
    columnSKU!: string;
    /** required for XLSX: sheet name */
    sheet?: string;
    /** required for XLSX: row that contains column names */
    headerRow?: number;
    /** required for XLSX: first row that contains data */
    dataRow?: number;

    [key: string]: any;

    constructor(data?: IDiscontinueProductsArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileName = _data["fileName"];
            this.vendorId = _data["vendorId"];
            this.columnSKU = _data["columnSKU"];
            this.sheet = _data["sheet"];
            this.headerRow = _data["headerRow"];
            this.dataRow = _data["dataRow"];
        }
    }

    static fromJS(data: any): DiscontinueProductsArgs {
        data = typeof data === 'object' ? data : {};
        let result = new DiscontinueProductsArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileName"] = this.fileName;
        data["vendorId"] = this.vendorId;
        data["columnSKU"] = this.columnSKU;
        data["sheet"] = this.sheet;
        data["headerRow"] = this.headerRow;
        data["dataRow"] = this.dataRow;
        return data;
    }
}

export interface IDiscontinueProductsArgs {
    fileName: string;
    vendorId: string;
    columnSKU: string;
    /** required for XLSX: sheet name */
    sheet?: string;
    /** required for XLSX: row that contains column names */
    headerRow?: number;
    /** required for XLSX: first row that contains data */
    dataRow?: number;

    [key: string]: any;
}

export class DiscontinueProductsResultDto implements IDiscontinueProductsResultDto {
    updated?: number;

    [key: string]: any;

    constructor(data?: IDiscontinueProductsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.updated = _data["updated"];
        }
    }

    static fromJS(data: any): DiscontinueProductsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscontinueProductsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["updated"] = this.updated;
        return data;
    }
}

export interface IDiscontinueProductsResultDto {
    updated?: number;

    [key: string]: any;
}

export enum UserProfileDtoRole {
    Admin = "Admin",
    User = "User",
}

export enum UserCreateDtoRole {
    Admin = "Admin",
    User = "User",
}

export enum UserUpdateDtoRole {
    Admin = "Admin",
    User = "User",
}

export enum RetailerVendorSettingsSendMethod {
    None = "None",
    SmtpSystem = "SmtpSystem",
    SmtpRetailer = "SmtpRetailer",
    Smtp = "Smtp",
    SftpRetailer = "SftpRetailer",
    Sftp = "Sftp",
    FtpRetailer = "FtpRetailer",
    Ftp = "Ftp",
    Walmart = "Walmart",
    CommerceHub = "CommerceHub",
    Amazon = "Amazon",
    Overstock = "Overstock",
    Faire = "Faire",
}

export enum RetailerVendorSettingsSchedulerMode {
    System = "System",
    Disabled = "Disabled",
    Custom = "Custom",
}

export enum ImportProductsArgsAction {
    None = "None",
    Discontinue = "Discontinue",
    Delete = "Delete",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}